import classNames from 'clsx';
import React, { type ReactNode, forwardRef, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import { LEFTNAV_ENABLED } from 'reactApp/appHelpers/featuresHelpers/features/leftnav';
import { getWorkspaceSuperAppService } from 'reactApp/services/WorkspaceSuperApp.class';

import styles from './TransitionWrapper.css';

interface IProps {
    children: ReactNode;
    onEntered?: () => void;
    onEnter?: () => void;
    onExited?: () => void;
    onExit?: () => void;
    isExpanded?: boolean;
}

export const TransitionWrapper = forwardRef<HTMLDivElement, IProps>(({ children, isExpanded, ...rest }, ref) => {
    const fixesForNav = useMemo(() => {
        return LEFTNAV_ENABLED || getWorkspaceSuperAppService()?.isB2CMode;
    }, []);

    return (
        <CSSTransition
            in={isExpanded}
            timeout={200}
            classNames={
                fixesForNav
                    ? {}
                    : {
                          exit: styles.animation_exit,
                          exitActive: styles.animation_exit_active,
                          enter: styles.animation_appear,
                          enterActive: styles.animation_appear_active,
                      }
            }
            {...rest}
        >
            <div
                className={classNames(styles.root, {
                    [styles.root_expand]: isExpanded || fixesForNav,
                })}
                ref={ref}
            >
                {children}
            </div>
        </CSSTransition>
    );
});

TransitionWrapper.displayName = 'TransitionWrapper';
